import React from 'react';
import {HealthParameterType} from '../../common/config';
import HealthComponent from '../health-component/health-component';

export default function OxygenSaturation() {
  return <HealthComponent type={HealthParameterType.OXYGEN_SATURATION} />;
}
